import endswitch from 'lodash.endswith';
import JasonVueNavigation from './jason-vue-navigation';

// 事件队列
let eventQueue = {
  go: [],
  back: []
};
// $navigation
let navigation = {
  // 路由历史表
  history: [],
  // 绑定事件
  on (eventStr, handler) {
    let event = formantEvent(eventStr);
    eventQueue[ event.name ].push({
      name: event.suffix,
      handler
    });
  },
  // 绑定一次性事件
  one (eventStr, handler) {
    let event = formantEvent(eventStr);
    let i = eventQueue[ event.name ].length;
    eventQueue[ event.name ].push({
      name: event.suffix,
      handler (...args) {
        handler(args);
        eventQueue[ event.name ][ i ].handler = new Function();
      }
    });
  },
  // 解绑事件
  off (eventStr) {
    let event = formantEvent(eventStr);
    eventQueue[ event.name ].forEach(item => {
      if (item.name === event.suffix) {
        item.handler = new Function();
      }
    });
  }
};

function install (Vue, router = null) {
  // beforeRouteLeave 时记录的临时 vm
  let fromVm = null;
  // history
  let { history } = navigation;
  // 检查 router
  if (!router) {
    throw new Error('options.router is required');
  }
  // 引入组件
  Vue.component(JasonVueNavigation.name, JasonVueNavigation);
  // 加入原型
  Vue.prototype.$navigation = navigation;
  // 设置 mixin 页面级组件离开时，记录 vm 实例
  Vue.mixin({
    beforeRouteLeave (to, from, next) {
      fromVm = this;
      next();
    }
  });
  // 导航确认时操作历史记录
  router.afterEach((to, from) => {
    // keep-alive cache
    let cache =
      fromVm ? fromVm.$vnode.parent.componentInstance.cache : null;
    // 最后记录的路由
    let historyLast = history[ history.length - 1 ] || {};
    // 后退
    let isBack = to.path === historyLast.path;
    // 前进
    let isGo = !isBack;
    // handler
    isBack && backHandler(fromVm, cache, to, from);
    isGo && goHandler(fromVm, cache, to, from);
  });
};

// import
export default {
  install
};

// script
if (window && window.Vue) {
  window.jasonVueNavigation = install;
}

// 前进 handler
// 1. 判断进入的组件是否永久缓存
//    为真 则不销毁缓存
//    为假 则先销毁缓存
// 2. 将 from 记录到历史中
// 3. 触发前进事件队列
function goHandler (fromVm, cache, to, from) {
  let { history } = navigation;
  let toKeepAlive = Boolean(to.meta.keepAlive);
  // 1
  if (cache && toKeepAlive === false) {
    destroy(cache, null, to.path);
  }
  // 2
  history.push({ path: from.path, vm: fromVm });
  // 3
  eventQueue.go.forEach(event => event.handler(to, from));
}

// 后退 handler
// 1. 根据 keepAlive 判断是否销毁当前页面级组件（是否永久缓存）
// 2. 删除最后一条路由记录
// 3. 触发回退事件队列
function backHandler (fromVm, cache, to, from) {
  let { history } = navigation;
  let fromKeepAlive = Boolean(from.meta.keepAlive);
  // 1
  if (fromKeepAlive === false) {
    destroy(cache, fromVm, from.path);
  }
  // 2
  history.pop();
  // 3
  eventQueue.back.forEach(event => event.handler(to, from));
}

// 销毁缓存
function destroy (cache, vm, path) {
  let { history } = navigation;
  let keys = Object.keys(cache);
  // 根据传入的 path 进行匹配，删除匹配到的缓存对象
  for (let i = 0; i < keys.length; i++) {
    let key = keys[ i ];
    if (endswitch(key, path)) {
      delete cache[ key ];
      break;
    }
  }
  // 缓存对象删除后还需要 $destroy vm 实例 才能完全删除缓存
  // back 会传入 vm
  vm && vm.$destroy();
  // go 不会传入 vm 要从历史中找
  vm || history.forEach((item) => {
    if (item.path === path) {
      item.vm && item.vm.$destroy();
      item.vm = null;
    }
  });
}

/**
 *  将事件名分离为 事件名 和 后缀，按照 ：分隔符
 *  @param { String } eventStr - 事件字符串
 *  @return { Object } event - event.name，event.suffix
 **/
function formantEvent (eventStr) {
  let signI = eventStr.indexOf(':');
  return {
    name: signI === -1 ? eventStr : eventStr.slice(0, signI),
    suffix: signI === -1 ? null : eventStr.slice(signI + 1)
  };
}